export default "__VITE_ASSET__BGBW0li7__"